<template>
  <div>
    <div
        v-if="authStore.maintenanceInfo !== null && authStore.maintenanceInfo.m !== null && authStore.hiddenMaintenanceNotificationId !== authStore.maintenanceInfo.m.id"
        class="fixed left-0 right-0 bottom-0 top-0 bg-black bg-opacity-50 z-[61] flex py-20 justify-center px-20">
      <div
          class="top-10 z-10 w-full max-w-[600px] h-40 rounded-md">
        <div id="alert-4"
             class="flex flex-col border-red-500 border p-10 mb-4 z-[99] text-dark rounded-lg bg-white w-full drop-shadow-sm dark:bg-gray-800 dark:text-blue-300"
             role="alert">

          <p class="text-xl font-semibold mt-2 text-red-500 flex gap-3 items-center">
            <svg class="flex-shrink-0 w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="red"
                 viewBox="0 0 20 20">
              <path
                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
            </svg>
            <span>{{ authStore.maintenanceInfo.m.name }}</span></p>
          <div class="mt-4 text-sm font-medium" v-html="renderText()">

          </div>
          <button @click="authStore.closeMaintenanceNotificationId(authStore.maintenanceInfo.m.id)" type="button"
                  class="ms-auto -mx-1.5 -my-1.5 bg-red-50 text-red-500 rounded-lg focus:ring-2 focus:ring-red-600 p-1.5 hover:bg-red-200 absolute top-4 right-4 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:text-blue-300 dark:hover:bg-gray-700"
                  data-dismiss-target="#alert-4" aria-label="Close">
            <span class="sr-only">Close</span>
            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div v-if="authStore.user !== null" class="flex">
      <SidebarLoggedIn v-model="clicked_menu"
                       :class="clicked_menu? 'z-50 h-[100vh] flex ' :' h-[100vh] -ml-[300px] lg:flex ' "
                       class=""></SidebarLoggedIn>
      <div v-if="clicked_menu"
           class="fixed z-50 left-0 right-0 bottom-0 pb-2 pt-4 flex justify-center w-[300px] text-white items-center bg-dark">
        <p class="pr-1 relative top-1 text-xs">Powered by</p>
        <a class="hover:underline font-semibold" href="https://softdreams.eu/" target="_blank">
          <img class="w-20" src="@/assets/img/logo_softdreams_alb.svg">
        </a>
      </div>
      <div
          :class="clicked_menu? 'w-custom' : 'w-full'"
          class="ml-[300px] transition-all duration-200"
          :style="cleoStore.isSidePanelOpen ? { paddingRight: cleoStore.sidePanelWidth + 'px', transition: cleoStore.isResizingSidePanel ? 'none' : undefined } : {}"
      >
        <svg :class="clicked_menu? 'left-[320px]':'left-5'" @click="lock_bodyScroll"
             class="cursor-pointer fixed z-[70] top-4 h-7 w-7 fill-black hover:fill-primary lg:hidden" height="384pt"
             viewBox="0 -53 384 384" width="384pt" xmlns="http://www.w3.org/2000/svg">
          <path
              d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"/>
          <path
              d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"/>
          <path
              d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"/>
        </svg>
        <svg :class="clicked_menu? 'left-[320px]':'left-5'" @click="lock_bodyScroll"
             class="cursor-pointer fixed z-[70] top-4  h-7 w-7 fill-black hover:fill-primary hidden lg:flex"
             height="384pt"
             viewBox="0 -53 384 384" width="384pt" xmlns="http://www.w3.org/2000/svg">
          <path
              d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"/>
          <path
              d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"/>
          <path
              d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"/>
        </svg>
        <NavbarLoggedIn></NavbarLoggedIn>

        <div class="relative w-full min-h-[90vh] bg-pagebg text-text">
          <div
              class="max-w-full mx-auto pt-16 px-7">
            <Transition name="fade" appear>
              <div>
                <RouterView :key="cleoStore.viewReloadKey"/>
              </div>
            </Transition>
          </div>
        </div>
      </div>
    </div>

    <template v-if="authStore.user !== null && authStore.accountPermissions.allowedAny([KPN.MANAGE_CLEO_ENABLED])">
      <AiChatWidget v-if="CLEO_ALLOWED_COMPANY_CODES.includes(authStore.user.companyCode) || ONECLICK_ENV === 'ana'"/>
      <CleoChatSidePanel v-if="CLEO_ALLOWED_COMPANY_CODES.includes(authStore.user.companyCode) || ONECLICK_ENV === 'ana'"/>
    </template>
  </div>
</template>

<script setup lang="ts">
import {ref, onMounted} from 'vue';
import NavbarLoggedIn from "@/components/layout/NavbarLoggedIn.vue";
import SidebarLoggedIn from "@/components/layout/SidebarLoggedIn.vue";
import AiChatWidget from "@/components/widgets/AiChatWidget.vue";
import CleoChatSidePanel from "@/components/widgets/CleoChatSidePanel.vue";
import {useAuthStore} from "@/stores/auth";
import {useCleoStore} from "@/stores/cleoChat";
import {KPN} from "@/types/KPN";
import Mustache from 'mustache';
import {DateFilterHelper} from "@/helpers/DateFilterHelper";

const clicked_menu = ref(false);
const authStore = useAuthStore();
const cleoStore = useCleoStore();
const ONECLICK_ENV = ref(import.meta.env.VITE_ONECLICK_ENV);
const CLEO_ALLOWED_COMPANY_CODES = [
  'TESTMBUCUR01',
  'BBMKSBUCUR01',
  'BRENNCHIAJ01',
  'DELTABUCUR03',
  'DRUCKMAGUR01',
  'DSMNUSTEFA01',
  'DUCTIBUZAU01',
  'ELTONPANTE01',
  'NOVASCLUJN01',
  'SOFSEBUCUR01',
  'REDBUBUCUR01',
  'ROHLIPIASE01',
  'ASESOBUCUR01',
  'PERNOBUCUR01',
  'SECOMTUNAR01',
  'CONTIBUCUR02',
  'TITANPANTE01',
  'GEISENURNB01',
  'BIOLOTIMIS01',
  'SMARTSOFIA01',
  'LEMANGREVE01',
  'VECTRBUCUR02',
  'LASTITIMIS01',
  'LERIDBUCUR01',
  'STDESBUCUR02',
  'ITALSDOMOD01',
  'RETURBUCUR01',
  'VISUABRASO01',
  'TRANSWONDE01',
  'DNSBIBUCUR01'
];

const lock_bodyScroll = () => {
  clicked_menu.value = !clicked_menu.value;
  //document.body.classList.add('lock_body_scroll');
}

onMounted(() => {
  if (window.innerWidth < 1025) {
    clicked_menu.value = false;
  } else {
    clicked_menu.value = true;

  }
});

const renderText = () => {
  const data = authStore.maintenanceInfo.r.serializeData();
  data.from = DateFilterHelper.FormatAsDateWithDotsAndHours(data.from);
  data.until = DateFilterHelper.FormatAsDateWithDotsAndHours(data.until);
  return Mustache.render(authStore.maintenanceInfo.m.text, data);
}
</script>
<style>
body {
  overflow-x: clip;
}

.w-custom {
  width: calc(100% - 300px) !important;
}

.w-custom1 {
  width: calc(100% - 265px) !important;
}

@media only screen and (max-width: 1023px) {
  .w-custom {
    width: 100% !important;
  }

  .w-custom1 {
    width: 100% !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>
